import { render, staticRenderFns } from "./IneligibleStudentListItem.vue?vue&type=template&id=7795bc18&scoped=true&"
import script from "./IneligibleStudentListItem.vue?vue&type=script&lang=js&"
export * from "./IneligibleStudentListItem.vue?vue&type=script&lang=js&"
import style0 from "./IneligibleStudentListItem.vue?vue&type=style&index=0&id=7795bc18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7795bc18",
  null
  
)

export default component.exports